import React, { useEffect, useRef } from 'react'
import ReactModal from 'react-modal'
import styled from 'styled-components'

import CloseIcon from '../../images/closeIcon.svg'
import { isFocusable } from '../../components/WithFocus';
import HtmlValidationHelper from '../HtmlValidationHelper';

ReactModal.setAppElement('#___gatsby')

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.0)',
    zIndex: '999',
  },
  content: {
    overflow: 'visible',
    boxShadow: '0px 10px 40px 0px rgba(0,0,0,0.12)',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'scale(0.9) translate(-55%, -55%)', //TODO - media scaling
    padding: '30px 70px 50px',
    //maxHeight: '98%', //Buggy
    border: 'none',
    maxWidth: '550px',
  },
}

const customStylesPostModal = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.0)',
    zIndex: '999',
  },
  content: {
    overflow: 'visible',
    boxShadow: '0px 10px 40px 0px rgba(0,0,0,0.12)',
    top: '0',
    left: '55%',
    border: 'none',
    width: '45%',
    height: '100%',
    overflow: 'scroll',
  },
}

const modalTitleId = "modal-title";

const focusFirstFocusableElement = ({contentEl}) => {
  const allDescendants = contentEl.querySelectorAll("*");

  for (const element of allDescendants) {
    if (isFocusable(element) === true) {
      element.focus();
      break;
    }
  }
}

const Modal = (props) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (modalRef.current != null) {
      HtmlValidationHelper.deleteNotAllowedAttributes(modalRef.current.node);
    }
  });

  return <ReactModal
    ref={modalRef}
    style={props.postModal ? customStylesPostModal : customStyles}
    title={props.title}
    isOpen={props.isOpen}
    shouldReturnFocusAfterClose={true}
    aria={{
      labelledby: modalTitleId
    }}
    onAfterOpen={focusFirstFocusableElement}
    {...props}
  >
    {props.closer && (
      <CloseModal onClick={props.onClose} aria-label="Zamknij">
        <img src={CloseIcon} alt="" />
      </CloseModal>
    )}
    <Heading id={modalTitleId}>{props.title}</Heading>
    {props.children}
  </ReactModal>
}

const CloseModal = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
`

const Heading = styled.h2``

export default Modal
